<span [ngClass]="{ primary: color }">{{
  label.length > 18 ? (label | slice: 0:18) + '...' : label
}}</span>
